import { render } from "./BatterVisitDateView.vue?vue&type=template&id=31d335b4&scoped=true"
import script from "./BatterVisitDateView.vue?vue&type=script&lang=js"
export * from "./BatterVisitDateView.vue?vue&type=script&lang=js"

import "./BatterVisitDateView.vue?vue&type=style&index=0&id=31d335b4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d335b4"]])

export default __exports__